// extracted by mini-css-extract-plugin
module.exports = {"LogoutWrapper":"Logout_LogoutWrapper__DXFpZ","Logout":"Logout_Logout__3XZq0","Submit":"Logout_Submit__kedQd"};